import {
  ADD_SECTION,
  ADD_CONTENT_BLOCK,
  SET_ACTIVE_STORE,
  SHOW_NOTIFICATION,
  UPDATE_CONTENT_BLOCK,
  REMOVE_SECTION,
  REMOVE_CONTENT_BLOCK,
  UPDATE_SECTION,
  UPDATE_STORE_CONFIG,
  MOVE_CONTENT_BLOCK,
  SET_MODIFIED,
  ADD_CATEGORY,
  ADD_SUBCATEGORY,
  UPDATE_CATEGORY,
  UPDATE_SUBCATEGORY,
  REMOVE_CATEGORY,
  REMOVE_SUBCATEGORY,
  SET_STORE_VERSIONS,
  UPDATE_BACKLINK
} from './actionTypes';
import { push } from 'connected-react-router';
import { fetchJson } from '../util/fetch';
import { getStores } from './storesActions';

const editStore = (dispatch, id, store, version) => {
  dispatch({
    type: SET_ACTIVE_STORE,
    id,
    store,
    version
  });
  dispatch(push('/edit'));
};

export const setActiveStore = id => {
  return dispatch => {
    return fetchJson(dispatch, `/api/store/${id}`, undefined, {
      '404': () => {
        editStore(dispatch, id, {
          landingPage: {
            sections: []
          }
        });
      }
    }).then(resp => {
      if (resp.ok) {
        editStore(dispatch, id, resp.json.store);
      }
    });
  };
};

export const loadStore = (id, name, version) => {
  return dispatch => {
    return fetchJson(
      dispatch,
      `/api/store/${id}/version/${version}`,
      undefined,
      {
        '404': () => {
          editStore(
            dispatch,
            id,
            {
              name: name,
              landingPage: {
                sections: []
              }
            },
            version
          );
        }
      }
    ).then(resp => {
      if (resp.ok) {
        editStore(dispatch, id, resp.json.store, version);
      }
    });
  };
};

export const deleteStore = id => dispatch => {
  return fetchJson(dispatch, `/api/store/${id}`, {
    method: 'DELETE'
  }).then(resp => {
    if (resp.ok) {
      return getStores()(dispatch);
    }
  });
};

export const addSection = () => {
  return dispatch => {
    dispatch({
      type: ADD_SECTION
    });
  };
};

export const removeSection = sectionIndex => {
  return dispatch => {
    dispatch({
      type: REMOVE_SECTION,
      sectionIndex
    });
  };
};

export const updateSections = sectionsData => {
  return dispatch => {
    dispatch({
      type: UPDATE_SECTION,
      sectionsData
    });
  };
};

export const addContentBlock = (index, contentBlock) => {
  return dispatch => {
    dispatch({
      type: ADD_CONTENT_BLOCK,
      index,
      contentBlock
    });
  };
};

export const updateContentBlock = (
  sectionIndex,
  contentBlockIndex,
  contentBlock
) => {
  return dispatch => {
    dispatch({
      type: UPDATE_CONTENT_BLOCK,
      sectionIndex,
      contentBlockIndex,
      contentBlock
    });
  };
};

export const removeContentBlock = (sectionIndex, contentBlockIndex) => {
  return dispatch => {
    dispatch({
      type: REMOVE_CONTENT_BLOCK,
      sectionIndex,
      contentBlockIndex
    });
  };
};

export const moveContentBlock = (
  srcSectionIdx,
  srcContentBlockIdx,
  dstSectionIdx,
  dstContentBlockIdx
) => {
  return dispatch => {
    dispatch({
      type: MOVE_CONTENT_BLOCK,
      srcSectionIdx,
      srcContentBlockIdx,
      dstSectionIdx,
      dstContentBlockIdx
    });
  };
};

export const addCategory = category => {
  return dispatch => {
    dispatch({
      type: ADD_CATEGORY,
      category
    });
  };
};

export const removeCategory = categoryIndex => {
  return dispatch => {
    dispatch({
      type: REMOVE_CATEGORY,
      categoryIndex
    });
  };
};

export const updateCategories = categoriesData => {
  return dispatch => {
    dispatch({
      type: UPDATE_CATEGORY,
      categoriesData
    });
  };
};

export const addSubcategory = (index, subcategory) => {
  return dispatch => {
    dispatch({
      type: ADD_SUBCATEGORY,
      index,
      subcategory
    });
  };
};

export const updateSubcategories = (categoryIndex, subcategories) => {
  return dispatch => {
    dispatch({
      type: UPDATE_SUBCATEGORY,
      categoryIndex,
      subcategories
    });
  };
};

export const removeSubcategory = (categoryIndex, subcategoryIndex) => {
  return dispatch => {
    dispatch({
      type: REMOVE_SUBCATEGORY,
      categoryIndex,
      subcategoryIndex
    });
  };
};

export const saveStore = (id, store) => (dispatch, getState) => {
  return fetchJson(dispatch, `/api/store/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getState().app.csrfToken
    },
    body: JSON.stringify({
      store
    })
  }).then(resp => {
    if (resp.ok) {
      dispatch({
        type: SHOW_NOTIFICATION,
        message: 'Store updated successfully',
        color: 'success'
      });
    }
  });
};

export const publish = (id, store, env) => dispatch => {
  return fetchJson(dispatch, `/api/store/${id}/version/${env}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      store
    })
  }).then(resp => {
    if (resp.ok) {
      dispatch({
        type: SHOW_NOTIFICATION,
        message: `Store successfully published to ${env}`,
        color: 'success'
      });
      dispatch({
        type: SET_MODIFIED,
        modified: false
      });
    }
  });
};

export const updateStoreConfig = (storeId, config) => {
  return dispatch => {
    dispatch({
      type: UPDATE_STORE_CONFIG,
      storeId,
      config
    });
  };
};

export const getStoreVersions = () => (dispatch, getState) => {
  return fetchJson(
    dispatch,
    `/api/store/${getState().activeStore.activeStore}/history`
  ).then(resp => {
    if (resp.ok) {
      dispatch({
        type: SET_STORE_VERSIONS,
        storeId: getState().activeStore.activeStore,
        versions: resp.json
      });
    }
  });
};

export const updateBacklink = ({ ...backlink }) => {
  return dispatch => {
    dispatch({
      type: UPDATE_BACKLINK,
      backlink
    });
  };
};



// WEBPACK FOOTER //
// ./src/store/editStoreActions.js